import { orderBy } from 'lodash'
import moment from 'moment'

const getters = {
  getOrderedBoards({ boards }) {
    return orderBy(
      boards,
      [
        object => {
          return moment(object.fecha_desde, 'DD/MM/YYYY')
        }
      ],
      ['desc']
    )
  }
}

export default getters
